export function mapJoin(map, keys) {
    if (!map || !keys || typeof map !== 'object' || !Array.isArray(keys)) {
        return '';
    }
    var labels = keys.map(function (key) { return map[key]; }).filter(function (label) { return !!label; });
    labels.sort();
    return labels.join(', ');
}
